import { useConfigurations } from '../../components/shared/useConfigurations';
import { ConfigurationName } from '../../enums/ConfigurationName';

const usePodPredictionReadonlyConfiguration = () => {
  const { isConfigurationEnabled } = useConfigurations();
  const isPodPredictionReadonlyEnabled = isConfigurationEnabled(ConfigurationName.PodPredictionReadonlyEnabled);

  const getPodPredictionReadonlyConfiguration = (): void => undefined;

  return {
    isPodPredictionReadonlyEnabled,
    getPodPredictionReadonlyConfiguration,
  };
};

export default usePodPredictionReadonlyConfiguration;
